import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  REDIRECT_URI_KEY_PARAM,
  REFRESH_TOKEN_KEY_PARAM,
  ROUTE_HOME,
  ROUTE_LOGIN,
} from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { refresh } from '@/common/interceptors/axios.AuthInterceptor';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';

const AutoLogin = () => {
  const { isLoggedIn, setIsLoggedIn } = useAuth();
  const { replace } = useHistory();
  const location = useLocation();
  const URLSearchParamsInstance = new URLSearchParams(location.search);
  const refreshToken = URLSearchParamsInstance.get(REFRESH_TOKEN_KEY_PARAM);
  const redirectUri = URLSearchParamsInstance.get(REDIRECT_URI_KEY_PARAM);

  useEffect(() => {
    if (!refreshToken) {
      replace(ROUTE_LOGIN);
    } else {
      refresh(refreshToken)
        .then(() => {
          setIsLoggedIn(true);
        })
        .finally(() => {
          if (redirectUri) {
            replace(redirectUri);
          } else {
            replace(ROUTE_HOME);
          }
        });
    }
  }, [isLoggedIn, redirectUri, refreshToken, replace, setIsLoggedIn]);

  return <PageLoader redirectUri={redirectUri} />;
};

export default AutoLogin;
